// extracted by mini-css-extract-plugin
export var toTop = "layout-module--to-top--2U01h";
export var footer = "layout-module--footer--3iD_9";
export var footerContent = "layout-module--footer-content--TfXen";
export var footerSocial = "layout-module--footer-social--30Grk";
export var footerSocialItem = "layout-module--footer-social-item--3DQmp";